import "core-js/modules/es6.regexp.match";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useEffect } from 'react';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var ResponsiveContext =
/*#__PURE__*/
React.createContext({
  breakpoints: {},
  orientation: {
    portrait: false,
    landscape: false
  },
  device: {
    isMobile: false,
    isDesktop: false,
    isAndroid: false,
    isIos: false,
    isChromium: false,
    isFirefox: false,
    isSafari: false
  },
  os: {
    isApple: false,
    isWindows: false
  }
});

function registerBreakpoint(theme, size) {
  var _ref;

  var _useState = useState(false),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    if (typeof window === "undefined") {
      return;
    }

    var query = window.matchMedia("(max-width: " + theme.breakpoints[size] + ")");
    setState(query.matches);

    var listener = function listener(e) {
      setState(query.matches);
    };

    query.addListener(listener);
    return function () {
      return query.removeListener(listener);
    };
  }, [size, theme]);
  return _ref = {}, _ref[size] = state, _ref;
}

function registerOrientation() {
  if (typeof window === "undefined") {
    return {
      portrait: false,
      landscape: false
    };
  }

  var mql = window.matchMedia("(orientation: portrait)");

  var updateOrientation = function updateOrientation(m) {
    return m.matches ? "portrait" : "landscape";
  };

  var _useState2 = useState(updateOrientation(mql.matches)),
      orientation = _useState2[0],
      setOrientation = _useState2[1];

  useEffect(function () {
    var updateOrientationHandler = function updateOrientationHandler(m) {
      return setOrientation(updateOrientation(m));
    };

    mql.addListener(updateOrientationHandler);
    return mql.removeListener(updateOrientationHandler);
  }, [mql]);
  return {
    portrait: orientation === "portrait",
    landscape: orientation === "landscape"
  };
}

function registerDevice() {
  if (typeof window === "undefined") {
    return {
      isMobile: false,
      isDesktop: false,
      isAndroid: false,
      isIos: false,
      isChromium: false,
      isFirefox: false,
      isSafari: false
    };
  }

  var _navigator = navigator,
      userAgent = _navigator.userAgent;
  var isChromium = Boolean(window.navigator.vendor.includes("Google"));
  var isFirefox = Boolean(window.navigator.userAgent.includes("Mozilla") && !window.navigator.vendor.includes("Apple") && !window.navigator.vendor.includes("Google"));
  var isSafari = Boolean(window.navigator.userAgent.includes("Mozilla") && window.navigator.vendor.includes("Apple"));
  var isOpera = Boolean(userAgent.match(/Opera Mini/i));
  var isWindows = Boolean(userAgent.match(/IEMobile/i));
  var isAndroid = Boolean(userAgent.match(/Android/i));
  var isIos = Boolean(userAgent.match(/iPhone|iPad|iPod/i));
  var isMobile = Boolean(isAndroid || isIos || isOpera || isWindows);
  var isDesktop = !isMobile;
  return {
    isMobile: isMobile,
    isDesktop: isDesktop,
    isAndroid: isAndroid,
    isIos: isIos,
    isChromium: isChromium,
    isFirefox: isFirefox,
    isSafari: isSafari
  };
}

var orderedBreakpoints = ["xs", "sm", "ms", "md", "ml", "lg", "xl", "xxl", "jb"];

function registerOS() {
  if (typeof window === "undefined") {
    return {
      isApple: false,
      isWindows: false
    };
  }

  var isApple = Boolean(navigator.appVersion.includes("Mac"));
  var isWindows = Boolean(navigator.appVersion.includes("Win"));
  return {
    isApple: isApple,
    isWindows: isWindows
  };
}

var ResponsiveProvider = function ResponsiveProvider(_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme;
  var state = {
    breakpoints: orderedBreakpoints.reduce(function (accumulator, bp) {
      return __spreadValues(__spreadValues({}, accumulator), registerBreakpoint(theme, bp));
    }, {}),
    orientation: registerOrientation(),
    device: registerDevice(),
    os: registerOS()
  };
  return (
    /* @__PURE__ */
    React.createElement(ResponsiveContext.Provider, {
      value: state
    }, children)
  );
};

ResponsiveProvider.displayName = "Maestro.ResponsiveProvider";
export { ResponsiveContext, ResponsiveProvider, orderedBreakpoints };